import { legacy } from '@/shared/api/client';

/** Uma linha de dispatch_runs -- ver controllers/dispatchLog.js no legado. */
export interface DispatchRun {
  _id: string;
  id_passbook?: string;
  id_campanha?: string;
  tipo_campanha?: string;
  tipo_disparo?: string;
  total?: number;
  status?: 'running' | 'success' | 'error';
  error?: string | null;
  created_at?: string;
  finished_at?: string | null;
  sent: number;
  failed: number;
}

export interface DispatchRunFilters {
  tipo_disparo?: string;
  status?: string;
  from?: string;
  limit?: number;
  idPassbooks?: string[];
}

export async function fetchDispatchRuns(filters: DispatchRunFilters = {}): Promise<DispatchRun[]> {
  const params = new URLSearchParams();
  if (filters.tipo_disparo) params.set('tipo_disparo', filters.tipo_disparo);
  if (filters.status) params.set('status', filters.status);
  if (filters.from) params.set('from', filters.from);
  if (filters.limit) params.set('limit', String(filters.limit));
  if (filters.idPassbooks && filters.idPassbooks.length > 0) {
    params.set('id_passbook', filters.idPassbooks.join(','));
  }

  const qs = params.toString();
  const res = await legacy.get<DispatchRun[]>(`/dispatch_runs${qs ? `?${qs}` : ''}`);
  return Array.isArray(res) ? res : [];
}

/** Uma pessoa/dispositivo de uma execução -- GET /dispatch_runs/:id/results. */
export interface DispatchRunResult {
  _id?: string;
  userName?: string;
  iduser?: string;
  serialNumber?: string;
  /** APP-ios | APP-android | iOS (Apple Wallet) | gwallet | outro = Wallet Android. Ausente em disparo antigo. */
  typeAccess?: string;
  status: 'success' | 'failed';
  /** Em falha: o motivo (push antigo sem typeAccess não tinha motivo gravado). */
  return_message?: string | null;
  date?: string;
}

export interface DispatchRunResults {
  run: DispatchRun & { success: number; updated_at?: string };
  rows: DispatchRunResult[];
  total: number;
}

export async function fetchDispatchRunResults(
  runId: string,
  params: { status?: string; q?: string; page: number; pageSize: number },
): Promise<DispatchRunResults> {
  const qs = new URLSearchParams();
  if (params.status) qs.set('status', params.status);
  if (params.q) qs.set('q', params.q);
  qs.set('page', String(params.page));
  qs.set('pageSize', String(params.pageSize));
  return legacy.get<DispatchRunResults>(`/dispatch_runs/${encodeURIComponent(runId)}/results?${qs.toString()}`);
}
